import moment from "moment";

export default function WorkOrderEntryModel(
  propertyId,
  siteId,
  siteName,
  territoryId,
  territoryName,
  customerId,
  customerName,
  redFlag,
  propertyAccessNotes,
  workitemtemplateid,
  workitemtemplateref,
  preferredAppointmentSlot,
  preferredAppointmentSlotTitle,
  appointmentConfirmed,
  appointmentConfirmedTitle,
  workitemcategoryid,
  workitemcategoryname,
  type,
  asset,
  category,
  subCategory,
  categoryName,
  subCategoryName,
  reporterType,
  poNumber,
  slahours
) {
  return {
    id: null,
    propertyId,
    reference: null,
    createdOn: null,
    closedOn: null,
    type,
    category,
    categoryName,
    subCategory,
    subCategoryName,
    state: null,
    status: null,

    workItems: [],

    asset,
    faultDescription: "",
    siteId,
    siteName,
    territoryId,
    territoryName,
    customerId,
    clientName: customerName,
    workitemtemplateid,
    workitemtemplateref,

    name: "UNKNOWN", // Name of WorkOrder
    reportername: "", // Person who reported issue
    ponumber: poNumber || "", // Optional Purchase Order number
    customername: "", // Occupier name
    customerphone: "", // Occupier phone number
    customeremail: "", // Occupier email, must be XXX@YYYY.ZZZ format. SV reject if it's not a valid email format but haven't specified what regex they're using...
    customervulnerability: "", // Optional occupier vulnerability
    createdon: moment().toISOString(), // When the WorkOrder was created, ISO-8601 format datetime
    diagnosis: "", // Diagnosis steps taken by Sw2 staff on phone
    redflag: redFlag,
    propertyaccessnotes: propertyAccessNotes,

    // These are missing from the web service at the moment
    reportertype: reporterType,
    reporteremail: "",
    reportertelephone: "",
    agreedoutsidesla: false,

    workitemcategoryid,
    workitemcategoryname,

    slahours,

    // Extra fields for WorkOrderItem entry
    preferredAppointmentDate: "",
    preferredAppointmentSlot,
    preferredAppointmentSlotTitle,
    appointmentConfirmed,
    appointmentConfirmedTitle,
    jobSpecificAccessNotes: "",
    disconnectelectricity: false,
    disconnecthotwater: false,
    disconnectheat: false,
    reconnectelectricity: false,
    reconnecthotwater: false,
    reconnectheat: false,

    workOrderItems: [], // WorkItemEditModel[]

    startby: null, // HACK: This field should not be here
  };
}
